import { combineReducers } from 'redux';

import generic from './generic';
import genericKeyValue from './genericKeyValue';
import { ENDPOINTS_ARRAY, STATIC_REDUCERS } from '../plannerConfig';

const REDUCER_MAPPINGS = {
  generic: (key, fallbackReducer) => generic(key, true, 'pk', fallbackReducer),
  genericUseId: (key, fallbackReducer) => generic(key, true, 'id', fallbackReducer),
  genericKeyValue,
  genericSingle: (key, fallbackReducer) => generic(key, false, 'pk', fallbackReducer, true),
};

const applicationReducers = [...ENDPOINTS_ARRAY, ...STATIC_REDUCERS].reduce((acc, curr) => ({
  ...acc,
  [curr.storeKey]: REDUCER_MAPPINGS[curr.reducer](curr.storeKey, curr.fallbackReducer),
}), {});

export default combineReducers(applicationReducers);
